import { Text, View } from "@react-pdf/renderer";
import { styles } from "../styles";
import { GraphViewer } from "../utils/graph";

export const OnuSla = ({ relatorio, graphcs, sharedOptions }) => {
	return (
		<View style={styles.firsPageContainer}>
			<View style={{ height: "20px" }} />
			<GraphViewer
				graphcs={graphcs?.graphOnuRxPower}
				sharedOptions={sharedOptions}
				description={"Potência Recebida (dBm)"}
				font={`Fonte: Dados coletados pelo ${relatorio?.source}`}
				options={{
					container: {
						width: "100%",
						marginTop: "0px",
					},
					img: {
						marginBottom: "-6px",
						marginTop: "-2px",
					},
				}}
			/>
			<Text
				style={[
					styles.text,
					{
						textIndent: "20px",
					},
				]}
			>
				O gráfico acima demonstra a variação da potência óptica recebida (em
				dBm) ao longo do período analisado. Esses valores representam a
				qualidade do sinal entregue ao equipamento, permitindo identificar
				padrões de degradação que possam impactar a estabilidade do serviço.
			</Text>
			<View style={{ height: "20px" }} />

			<GraphViewer
				graphcs={graphcs?.graphOnuAvailability}
				sharedOptions={sharedOptions}
				description={"Disponibilidade da ONU"}
				font={`Fonte: Dados coletados pelo ${relatorio?.source}`}
				options={{
					container: {
						width: "100%",
						marginTop: "-10px",
						alignItems: "center",
						justifyContent: "center",
					},
					img: {
						width: "50%",
						alignSelf: "center",
						marginBottom: "-2px",
					},
				}}
			/>
			<Text
				style={[
					styles.text,
					{
						textIndent: "20px",
					},
				]}
			>
				Este gráfico apresenta o percentual de tempo de disponibilidade dos
				equipamentos ONU durante o período do relatório. O gráfico demonstra o
				percentual de tempo em que a ONU permaneceu dentro dos parâmetros
				aceitáveis de operação, refletindo a estabilidade geral do serviço.
			</Text>
			{/** Tabela */}
			<View style={{ height: "10px" }} />
			<View
				style={{
					...styles.tableDescription,
				}}
			>
				{((relatorio?.rxPowerMean != null && relatorio?.rxPowerRef != null) ||
					(relatorio?.availability != null &&
						relatorio?.availabilityRef != null)) && (
					<View style={styles.tableDescriptionHeader}>
						<Text style={styles.metricsTable.leftColumn}>Métrica</Text>
						<Text style={styles.metricsTable.middleColumn}>
							Resultados no Período
						</Text>
						<Text>SLA Esperado</Text>
					</View>
				)}
				{/* Potência Recebida */}
				{relatorio?.rxPowerMean != null && relatorio?.rxPowerRef != null && (
					<View style={styles.tableDescriptionRow}>
						<View style={styles.metricsTable.leftColumn}>
							<Text>Potência Média Recebida (dBm)</Text>
						</View>
						<View style={styles.metricsTable.middleColumn}>
							<Text>{`${relatorio?.rxPowerMean?.toFixed(2)} dBm`}</Text>
						</View>
						<View style={styles.metricsTable.rightColumn}>
							<Text>{`> ${relatorio?.rxPowerRef?.toFixed(2)} dBm`}</Text>
						</View>
					</View>
				)}
				{/* Disponibilidade */}
				{relatorio?.availability != null &&
					relatorio?.availabilityRef != null && (
						<View
							style={{ ...styles.tableDescriptionRow, borderBottom: "none" }}
						>
							<View style={styles.metricsTable.leftColumn}>
								<Text>Disponibilidade (%)</Text>
							</View>
							<View style={styles.metricsTable.middleColumn}>
								<Text>{`${relatorio?.availability?.toFixed(2)} %`}</Text>
							</View>
							<View style={styles.metricsTable.rightColumn}>
								<Text>{`> ${relatorio?.availabilityRef?.toFixed(2)} %`}</Text>
							</View>
						</View>
					)}
				{relatorio?.observacoes && (
					<View
						style={{
							...styles.metricsInColumn,
							marginTop: 10,
							padding: 10,
							backgroundColor: "#f5f5f5",
							borderRadius: 4,
							width: "100%",
						}}
						wrap
					>
						<Text
							style={{
								fontSize: 12,
								fontFamily: "Times-Bold",
								marginBottom: 5,
								color: "#000000",
							}}
						>
							Observações:
						</Text>

						<Text
							style={{
								fontSize: 12,
								textAlign: "justify",
								fontFamily: "Times-Roman",
								lineHeight: 1.5,
								width: "100%",
							}}
						>
							{relatorio.observacoes}
						</Text>
					</View>
				)}
			</View>
		</View>
	);
};
